import { render, staticRenderFns } from "./AutotunerWidget.vue?vue&type=template&id=09877b27&scoped=true&"
import script from "./AutotunerWidget.vue?vue&type=script&lang=js&"
export * from "./AutotunerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09877b27",
  null
  
)

export default component.exports